import moment from "moment";
import React, { lazy, Component, Suspense } from "react";

import {
  Animated,
  Dimensions,
  Platform,
  ScrollView,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
  Image
} from "react-native";
import { Button, Icon } from "react-native-elements";
import { Hoverable } from "react-native-web-hooks";
import { connect } from "react-redux";
import { compose } from "recompose";
import { setPostCommentDetails } from "../actionCreator/PostCommentDetailsAction";
import { setPostDetails } from "../actionCreator/PostDetailsAction";
import applloClient from "../client";
import Colors from "../constants/Colors";
import ConstantFontFamily from "../constants/FontFamily";
import {
  ClikJoinMutation,
  RejectClikMemberMutation,
  InviteToClik,
  AcceptClik
} from "../graphqlSchema/graphqlMutation/FollowandUnFollowMutation";
import {
  DeleteAccountNotificationMutation,
  GetAccountNotificationsMutation
} from "../graphqlSchema/graphqlMutation/Notification";
import {
  ClikJoinVariables,
  InviteToClikVariables,
  RejectClikMemberVariables
} from "../graphqlSchema/graphqlVariables/FollowandUnfollowVariables";
import ButtonStyle from "../constants/ButtonStyle";
import { FollowMutation } from "../graphqlSchema/graphqlMutation/FollowandUnFollowMutation";
import { UserFollowVariables } from "../graphqlSchema/graphqlVariables/FollowandUnfollowVariables";
import ShadowSkeletonNotification from "../components/ShadowSkeletonNotification";
import { saveUserLoginDaitails } from "../actionCreator/UserAction";
import { UserFollowingMutation } from "../graphqlSchema/graphqlMutation/UserMutation";
import { getTrendingCliksProfileDetails } from "../actionCreator/TrendingCliksProfileAction";
import { getCurrentUserProfileDetails } from "../actionCreator/UserProfileDetailsAction";
import NavigationService from "../library/NavigationService";
import { feedFluctuation, screen } from "../reducers/action/Completed";
// import ConstantColors from '../constants/Colors'

const HeaderRight = lazy(() => import("../components/HeaderRight"))



class NotificationScreen extends Component {

  constructor(props) {
    super(props);
    this.Pagescrollview = null;
    this.state = {
      showsVerticalScrollIndicatorView: false,
      currentScreentWidth: 0,
      CommentNotificationList: [],
      CommentLoading: false,
      showEmptyIcon: false
    };
    moment.updateLocale("en", {
      relativeTime: {
        future: "in %s",
        past: "%s ago",
        s: "a few seconds",
        ss: "%ds",
        m: "1m",
        mm: "%dm",
        h: "1h",
        hh: "%dh",
        d: "1d",
        dd: "%dd",
        w: "1w",
        ww: "%dw",
        M: "1M",
        MM: "%dM",
        y: "1y",
        yy: "%dy"
      }
    });
  }

  componentDidMount = () => {
    this.props.searchOpenBarStatus(false)
    this.getAccountNotifications();
    this.props.screen('notificationScreen')
  };

  getAccountNotifications = () => {
    if (this.state.CommentNotificationList.length == 0) {
      this.setState({
        CommentLoading: true
      });
    }
    applloClient
      .query({
        query: GetAccountNotificationsMutation,
        variables: {
          first: 100,
          after: null,
          id: "Account:CurrentUser",
        },
        fetchPolicy: "no-cache"
      })
      .then(async res => {
        this.setState({
          CommentLoading: false,
          CommentNotificationList: res.data.node.notifications && res.data.node.notifications.edges && res.data.node.notifications.edges,
          showEmptyIcon:
            res.data.node.notifications && res.data.node.notifications.edges && res.data.node.notifications.edges.length == 0 ? true : false
        });
        let timer = setTimeout(() => {
          this.getAccountNotifications();
        }, 60000);
      });
  };

  deleteAccountNotifications = id => {
    applloClient
      .query({
        query: DeleteAccountNotificationMutation,
        variables: {
          notification_id: id
        },
        fetchPolicy: "no-cache"
      })
      .then(async res => {
        this.getAccountNotifications();
      });
  };



  joinClik = async (clik_id, notification_id, user_id) => {
    ClikJoinVariables.variables.clik_id = clik_id;
    ClikJoinVariables.variables.qualification = "";

    try {
      await applloClient
        .query({
          query: ClikJoinMutation,
          variables: {
            clik_id: clik_id,
            qualification: null,
          },
          fetchPolicy: "no-cache"
        })
        .then(async res => {
          console.log(res, 'result');
        });
    } catch (e) {
      console.log(e);
    }
  };

  inviteClik = async (clik_id, user_id, notification_id) => {
    InviteToClikVariables.variables.clik_id = clik_id;
    InviteToClikVariables.variables.invited_users = [
      { user_id: "User:" + user_id }
    ];
    try {
      await applloClient
        .query({
          query: InviteToClik,
          variables: {
            clik_id: clik_id,
            invited_users: InviteToClikVariables.variables.invited_users
          },
          fetchPolicy: "no-cache"
        })
        .then(async res => {
          this.deleteAccountNotifications(notification_id);
        });
    } catch (e) {
      console.log(e);
    }
  };

  acceptClik = async (application_id) => {

    try {
      await applloClient
        .query({
          query: AcceptClik,
          variables: {
            application_id: application_id,
            member_type: "ADMIN"
          },
          fetchPolicy: "no-cache"
        })
        .then(async res => {

        });
    } catch (e) {
      console.log(e);
    }


  }

  rejectClik = async (clik_id, user_id, notification_id) => {
    RejectClikMemberVariables.variables.clik_id = clik_id;
    RejectClikMemberVariables.variables.user_id = user_id;
    try {
      await applloClient
        .query({
          query: RejectClikMemberMutation,
          ...RejectClikMemberVariables,
          fetchPolicy: "no-cache"
        })
        .then(async res => {
          this.deleteAccountNotifications(notification_id);
        });
    } catch (e) {
      console.log(e);
    }
  };

  followUser = async (username, notification_id) => {
    UserFollowVariables.variables.user_id = username;
    UserFollowVariables.variables.follow_type = "FOLLOW";
    try {
      await applloClient
        .query({
          query: FollowMutation,
          variables: {
            id: username,
            follow_type: "FOLLOW"
          },
          fetchPolicy: "no-cache"
        })
        .then(async res => {

          let userfollow = await applloClient
            .query({
              query: UserFollowingMutation,
              variables: {
                id: "User:CurrentUser",
                first: 20
              },
              fetchPolicy: "no-cache"
            }).then(e => {
              return e.data.node.users_following.edges
            })


          let userData = {
            data: this.props.profileData,
            externalfollow: this.props.getUserFollowFeedList,
            clikfollow: this.props.getUserFollowCliksList,
            topicfollow: this.props.getUserFollowTopicList,
            userfollow: userfollow

          }
          await this.props.saveLoginUser(userData);
        });
    } catch (e) {
      console.log(e);
    }
  };

  getUserStar = UserName => {
    let index = 0;
    index = this.props.getUserFollowUserList.findIndex(
      i =>
        i.node.user.username.replace("user:", "") == UserName &&
        UserName.replace("user:", "")
    );
    return index;
  };

  goToClikProfile = id => {
    this.props.ClikId({
      id: id,
      type: "feed"
    });
  };

  goToUserProfile = async (username) => {
    await this.props.userId({
      username: username,
      type: "feed",
    });
    await this.props.navigation.navigate("profile", {
      username: username,
      type: "feed",
      postId: ' '
    });
  };

  commentPost = (id) => {
    NavigationService.navigate("commentID", { id: id })
    this.props.feedFluctuation(false)
  }

  render() {

    const regex = /<\/?[^>]+(>|$)/g;
    (/\s/g, "&nbsp;")
    return (
      <View
        style={{
          flex: 1,
          backgroundColor: Colors.customeBackgroundColor,
          width: "100%",
        }}
      >
        {/* {Dimensions.get("window").width <= 750 ? (
          <Animated.View
            style={{
              left: 0,
              right: 0,
              zIndex: 10,
              overflow: "hidden",
              borderRadius: Dimensions.get("window").width <= 750 ? 0 : 6
            }}
          >
            <View
              style={{
                alignItems: "center",
                justifyContent: "center"
              }}
            >
              <View
                style={{
                  width: "100%",
                  height: 50,
                  flexDirection: "row",
                  alignItems: "center",
                  marginBottom: Dimensions.get("window").width <= 750 ? 0 : 10,
                  backgroundColor: "#000",
                  borderRadius: Dimensions.get("window").width <= 750 ? 0 : 6,
                }}

              >
                <TouchableOpacity
                  style={[ButtonStyle.headerBackStyle, {width: !this.props.getsearchBarStatus ? "5%" : 0,
                  flexDirection: "row",
                  justifyContent: "flex-start",
                  alignSelf: "center",}]}
                  onPress={() => {
                    this.props.searchOpenBarStatus(false)
                    let nav = this.props.navigation.dangerouslyGetParent()
                      .state;
                    if (nav.routes.length > 1) {
                      this.props.navigation.goBack();
                      return;
                    } else {
                      this.props.navigation.navigate("home");
                    }
                  }}
                >
                  <Icon
                    color={"#fff"}
                    name="angle-left"
                    type="font-awesome"
                    size={40}
                  />
                </TouchableOpacity>
                {!this.props.getsearchBarStatus &&
                  <TouchableOpacity
                  // style={{justifyContent:'center'}}
                    style={[ButtonStyle.headerTitleStyle,{ backgroundColor: '#000' }]}
                  >
                    <Text
                      style={{
                        textAlign: 'center',
                        color: "#fff",
                        fontWeight: "bold",
                        fontSize: 18,
                        fontFamily: ConstantFontFamily.defaultFont
                      }}
                    >
                      Notifications
                    </Text>
                  </TouchableOpacity>
                }
                <View style={[ButtonStyle.headerRightStyle, { width: this.props.getsearchBarStatus ? '95%' : '45%' }]}>
                  <Suspense fallback={null}>
                    <HeaderRight navigation={this.props.navigation} />
                  </Suspense>
                </View>
              </View>
            </View>
          </Animated.View>

        ) : null
        } */}

        {this.state.CommentNotificationList.length == 0 &&
          this.state.showEmptyIcon == true && (
            <View
              style={{
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <Icon
                color={"#000"}
                iconStyle={{
                  color: "#fff",
                  justifyContent: "center",
                  alignItems: "center",
                  alignSelf: "center"
                }}
                reverse
                name="bell"
                type="font-awesome"
                size={20}
                containerStyle={{
                  alignSelf: "center"
                }}
              />
              <Text
                style={{
                  fontSize: 14,
                  fontWeight: "bold",
                  fontFamily: ConstantFontFamily.defaultFont,
                  color: "#000",
                  alignSelf: "center"
                }}
              >
                No Notifications
              </Text>
            </View>
          )}

        <ScrollView
          ref={scrollview => {
            this.Pagescrollview = scrollview;
          }}
          showsVerticalScrollIndicator={false}
          onLayout={event => {
            let { x, y, width, height } = event.nativeEvent.layout;
            if (width < 1024) {
              this.setState({
                showsVerticalScrollIndicatorView: true,
                currentScreentWidth: width
              });
            } else {
              this.setState({
                showsVerticalScrollIndicatorView: false,
                currentScreentWidth: width
              });
            }
          }}
          style={{
            height:
              Platform.OS !== "web"
                ? null
                : Dimensions.get("window").height - 80,
          }}
        >


          {this.state.CommentLoading == true ? (
            <ShadowSkeletonNotification />
          ) : (
            <View>

              {this.state.CommentNotificationList.map((item, i) => {

                if (item.node.__typename == "CommentNotification") {
                  return (

                    <View
                      style={[
                        ButtonStyle.normalFeedStyleForDashboard,
                        {
                          width: '96%',
                          marginLeft: Dimensions.get("window").width <= 1200 ? 8 : 15,
                          backgroundColor: "#fff",
                          marginTop: 15
                        }
                      ]}
                    >
                      <View

                        style={{
                          flexDirection: "row",
                          width: "100%"
                        }}
                      >
                        <View
                          style={{
                            width: "10%",
                            justifyContent: "center"
                          }}
                        >
                          <Icon
                            color={Colors.blueColor}
                            name={"comment"}
                            type="font-awesome"
                            size={30}
                            iconStyle={{ alignSelf: "center" }}
                            containerStyle={{ alignSelf: "center" }}
                          />
                          <Text
                            style={{
                              marginTop: 10,
                              textAlign: "center",
                              color: "#000",
                              fontSize: 12,
                              fontWeight: "bold",
                              fontFamily: ConstantFontFamily.defaultFont
                            }}
                          >
                            {" "}
                            {moment
                              .utc(item.node.created)
                              .local()
                              .fromNow(true)}{" "}
                          </Text>
                        </View>

                        <View
                          style={{
                            width: "90%"
                          }}
                        >
                          <View
                            style={{
                              width: "100%",
                              padding: 20,
                            }}
                          >
                            <Text
                              style={{
                                color: "#000",
                                fontSize: 15,
                                fontFamily:
                                  ConstantFontFamily.defaultFont
                              }}
                            >
                              <Text
                                style={{
                                  color: "#000",
                                  fontFamily: ConstantFontFamily.defaultFont,
                                  fontSize: 13,
                                  fontWeight: 'bold',
                                }}
                                onPress={() => {
                                  this.commentPost(item.node?.their_comment?.id.replace("Comment:", ""))
                                  item.node.my_content ? this.props.setNotificationId(item.node.my_content && item.node.my_content.id) : ''
                                }
                                }
                              >


                                {
                                  item?.node?.their_comment?.__typename == "Comment" ?
                                    item.node?.their_comment && item.node?.their_comment?.text &&
                                    item.node?.their_comment?.text?.replace(regex, '').substring(0, 150)
                                    :
                                    item.node?.my_content && item.node?.my_content?.title &&
                                    item.node.my_content.title
                                }


                              </Text>

                            </Text>
                            <Hoverable>
                              {isHovered => (
                                <TouchableOpacity
                                  style={{ flexDirection: 'row', alignItems: 'center' }}
                                  onPress={() => this.goToUserProfile(item.node?.their_comment?.author?.username && item.node?.their_comment?.author?.username)}
                                >
                                  <Image
                                    source={{
                                      uri: item.node?.their_comment?.__typename == "Comment" ?
                                        item.node?.their_comment?.author?.profile_pic :
                                        (item.node?.their_comment?.author?.profile_pic?.slice(-3) == "000" || item.node?.their_comment?.author?.profile_pic?.slice(-2) == "00") ?
                                          require("../assets/image/default-image.png") :
                                          require("../assets/image/default-image.png"),
                                    }}
                                    style={{
                                      width: 30,
                                      height: 30,
                                      borderRadius: 15,
                                    }}
                                  />
                                  <Text style={[styles.usernameText, {
                                    textDecorationLine:
                                      isHovered == true ? "underline" : "none",
                                  }]}
                                  >
                                    {item.node?.their_comment?.__typename == "Comment" ?
                                      item.node?.their_comment && item.node?.their_comment?.author &&
                                      "@" + item.node?.their_comment?.author
                                        ?.username : "Post:"}
                                  </Text>
                                </TouchableOpacity>
                              )}
                            </Hoverable>
                          </View>


                          <View
                            style={{
                              marginBottom: 10,
                              padding: 20
                            }}
                          >


                            <Text
                              style={{
                                color: "#000",
                                fontFamily: ConstantFontFamily.defaultFont,
                                fontSize: 13,
                                fontWeight: 'bold',
                              }}
                              onPress={() => {
                                this.commentPost(item.node?.their_comment?.id.replace("Comment:", ""))
                                item.node.my_content ? this.props.setNotificationId(item.node.my_content && item.node.my_content.id) : ''
                              }
                              }
                            >

                              {item.node.their_comment && item.node.their_comment.text &&
                                item.node.their_comment.text.replace(regex, '').substring(0, 150)}
                              {"..."}
                            </Text>

                            <Hoverable>
                              {isHovered => (
                                <TouchableOpacity
                                  style={{ flexDirection: 'row', alignItems: 'center' }}
                                  onPress={() => this.goToUserProfile(item.node?.their_comment?.author?.username && item.node?.their_comment?.author?.username)}
                                >
                                  <Image
                                    source={{
                                      uri: item.node.their_comment && item.node.their_comment.author ?
                                        item.node.their_comment.author.profile_pic :
                                        (item.node.their_comment.author.profile_pic?.slice(-3) == "000" || item.node.their_comment.author.profile_pic?.slice(-2) == "00") ?
                                          require("../assets/image/default-image.png") :
                                          require("../assets/image/default-image.png"),
                                    }}
                                    style={{
                                      width: 30,
                                      height: 30,
                                      borderRadius: 15,
                                    }}
                                  />
                                  <Text style={[styles.usernameText, {
                                    textDecorationLine:
                                      isHovered == true ? "underline" : "none",
                                  }]}
                                    onPress={() => this.goToUserProfile(
                                      item.node.their_comment.author
                                        .username)}
                                  >
                                    @
                                    {item.node.their_comment && item.node.their_comment.author &&
                                      item.node.their_comment.author
                                        .username}{" "}

                                  </Text>
                                </TouchableOpacity>
                              )}
                            </Hoverable>
                          </View>
                        </View>

                        <View
                          style={{ height: 2, backgroundColor: "#e1e1e1" }}
                        ></View>
                      </View>
                    </View>
                  );
                }
                else if (
                  item.node.__typename ==
                  "ClikInviteNotification"
                ) {
                  return (
                    <TouchableOpacity
                      style={[
                        ButtonStyle.normalFeedStyleForDashboard, styles.boxWidth,
                      ]}
                    >
                      <View
                        style={{ flexDirection: "row" }}
                      >
                        <View
                          style={{
                            width: "10%",
                            justifyContent: "center"
                          }}
                        >

                          <View style={{ alignSelf: 'center' }}>
                            <Image
                              source={require("../assets/image/logolastOne.png")}
                              style={{
                                width: 30,
                                height: 30,
                                borderRadius: 8
                              }}
                            />
                          </View>
                          <Text
                            style={{
                              marginTop: 10,
                              textAlign: "center",
                              color: "#000",
                              fontSize: 12,
                              fontWeight: "bold",
                              fontFamily: ConstantFontFamily.defaultFont
                            }}
                          >
                            {moment
                              .utc(item.node.created)
                              .local()
                              .fromNow(true)}
                          </Text>
                        </View>

                        <View
                          style={{
                            width: "85%"
                          }}
                        >
                          <View
                            style={{
                              flexDirection: "column",
                              alignItems: "center",
                              justifyContent: 'center',
                              width: "100%",
                            }}
                          >
                            <View style={{ flexDirection: 'row', alignItems: 'center' }}>

                              <Hoverable>
                                {isHovered => (
                                  <TouchableOpacity
                                    style={{ flexDirection: 'row', alignItems: 'center' }}
                                    onPress={() => this.goToUserProfile(item.node.notifier.username)}

                                  >
                                    <Image
                                      source={{
                                        uri: item.node.notifier.profile_pic ? item.node.notifier.profile_pic :
                                          (item.node.notifier.profile_pic?.slice(-3) == "000" || item.node.notifier.profile_pic?.slice(-2) == "00") ?
                                            require("../assets/image/default-image.png") :
                                            require("../assets/image/default-image.png"),
                                      }}
                                      style={{
                                        width: 30,
                                        height: 30,
                                        borderRadius: 15,
                                      }}
                                    />
                                    <Text
                                      style={[ButtonStyle.profileTitleStyle, {
                                        color: "#000",
                                        textDecorationLine:
                                          isHovered == true ? "underline" : "none"
                                      }]}
                                    >

                                      @{item.node.notifier.username}
                                    </Text>
                                  </TouchableOpacity>
                                )}
                              </Hoverable>


                              <Text
                                style={{
                                  color: "#000",
                                  fontSize: 13,
                                  fontWeight: "bold",
                                  fontFamily: ConstantFontFamily.defaultFont
                                }}
                              >

                                invited you to
                              </Text>
                            </View>

                            <Hoverable>
                              {isHovered => (
                                <TouchableOpacity
                                  style={{
                                    justifyContent: 'center',
                                    marginTop: 10,
                                    alignItems: 'center',
                                    flexDirection: 'row'
                                  }}
                                  onPress={() =>
                                    this.goToClikProfile(item.node.clik.name)
                                  }
                                >
                                  <Image
                                    source={{
                                      uri: item.node.clik.profile_pic ? item.node.clik.profile_pic : "data:image/png;base64,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",
                                    }}
                                    style={{
                                      width: 30,
                                      height: 30,
                                      borderRadius: 5,
                                    }}
                                  />

                                  <View style={{ backgroundColor: "#E8F5FA", paddingVertical: 5, borderRadius: 6, marginLeft: 10 }}>
                                    <Text
                                      style={[ButtonStyle.profileTitleStyle, {
                                        width: "100%",
                                        color: "#4169e1",
                                        textDecorationLine:
                                          isHovered == true ? "underline" : "none"
                                      }]}
                                    >

                                      #{item.node.clik.name}
                                    </Text>
                                  </View>

                                </TouchableOpacity>
                              )}
                            </Hoverable>
                            <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                              <Button
                                title={"Join"}
                                titleStyle={[ButtonStyle.wtitleStyle, { fontFamily: ConstantFontFamily.HeaderBoldFont }]}
                                buttonStyle={[ButtonStyle.gbackgroundStyle, styles.notificationButtonStyle, { borderWidth: 0, marginHorizontal: 10 }]}
                                containerStyle={[ButtonStyle.containerStyle, { marginBottom: 0 }]}
                                onPress={() =>
                                  this.joinClik(
                                    item.node.clik.id,
                                    item.node.id,
                                    item.node.notifier.id
                                  )
                                }
                              />

                              <Button
                                title={"Reject"}
                                titleStyle={[ButtonStyle.wtitleStyle, { fontFamily: ConstantFontFamily.HeaderBoldFont }]}
                                buttonStyle={[ButtonStyle.rbackgroundStyle, styles.notificationButtonStyle, { marginHorizontal: 10, borderWidth: 0 }]}
                                containerStyle={[ButtonStyle.containerStyle, { marginBottom: 0 }]}
                                onPress={() =>
                                  this.deleteAccountNotifications(item.node.id)
                                }
                              />
                            </View>
                          </View>
                        </View>
                      </View>
                    </TouchableOpacity>
                  );
                }

                else if (
                  item.node.__typename ==
                  "ClikInviteAcceptedNotification"
                ) {
                  return (

                    <View
                      style={[
                        ButtonStyle.normalFeedStyleForDashboard, styles.boxWidth,

                      ]}
                    >
                      <TouchableOpacity
                        style={{ flexDirection: "row" }}
                      >
                        <View
                          style={{
                            width: "10%",
                            justifyContent: "center"
                          }}
                        >
                          <View style={{ alignSelf: 'center' }}>
                            <Image
                              source={require("../assets/image/logolastOne.png")}
                              style={{
                                width: 30,
                                height: 30,
                                borderRadius: 8
                              }}
                            />
                          </View>

                          <Text
                            style={{
                              marginTop: 10,
                              textAlign: "center",
                              color: "#000",
                              fontSize: 12,
                              fontWeight: "bold",
                              fontFamily: ConstantFontFamily.defaultFont
                            }}
                          >
                            {moment
                              .utc(item.node.created)
                              .local()
                              .fromNow(true)}
                          </Text>
                        </View>
                        <View
                          style={{
                            width: "85%"
                          }}
                        >
                          <View
                            style={{

                              padding: 5,
                              flexDirection: "column",
                              alignSelf: "center",
                              alignItems: "center",
                              justifyContent: 'center'
                            }}
                          >
                            <View style={{ flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                              <Hoverable>
                                {isHovered => (
                                  <TouchableOpacity
                                    style={{
                                      flexDirection: 'row',
                                      alignItems: 'center'
                                    }}
                                    onPress={() => this.goToUserProfile(item.node && item.node.notifier ? item.node.notifier.username : item.node.notifier.username)}
                                  >
                                    <Image
                                      source={{
                                        uri: item.node?.notifier?.profile_pic ? item.node.notifier.profile_pic
                                          :
                                          (item.node.notifier.profile_pic?.slice(-3) == "000" || item.node.notifier.profile_pic?.slice(-2) == "00") ?
                                            require("../assets/image/default-image.png") :
                                            require("../assets/image/default-image.png"),
                                      }}
                                      style={{
                                        width: 30,
                                        height: 30,
                                        borderRadius: 15,
                                      }}
                                    />

                                    <Text
                                      style={[styles.usernameText, {
                                        textDecorationLine:
                                          isHovered == true ? "underline" : "none",
                                      }]}
                                    >
                                      @{item.node && item.node.notifier ? item.node.notifier.username : item.node.notifier.username}
                                    </Text>

                                  </TouchableOpacity>
                                )}
                              </Hoverable>
                              <Text
                                style={{
                                  color: "#000",
                                  fontSize: 13,
                                  fontWeight: "bold",
                                  fontFamily: ConstantFontFamily.defaultFont
                                }}
                              >

                                joined

                              </Text>
                            </View>

                            <Hoverable>
                              {isHovered => (
                                <TouchableOpacity
                                  style={{
                                    justifyContent: 'center',
                                    marginTop: 10,
                                    alignItems: 'center',
                                    flexDirection: 'row'
                                  }}
                                  onPress={() =>
                                    this.goToClikProfile(
                                      item.node.clik.name
                                    )
                                  }
                                >
                                  <Image
                                    source={{
                                      uri: item.node.clik.profile_pic ? item.node.clik.profile_pic : "data:image/png;base64,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",
                                    }}
                                    style={{
                                      width: 30,
                                      height: 30,
                                      borderRadius: 5,
                                    }}
                                  />

                                  <View style={{ backgroundColor: "#E8F5FA", paddingVertical: 5, borderRadius: 6, marginLeft: 10 }}>
                                    <Text
                                      style={{
                                        width: "100%",
                                        color: "#4169e1",
                                        fontSize: 15,
                                        fontFamily:
                                          ConstantFontFamily.defaultFont,
                                        textDecorationLine:
                                          isHovered == true ? "underline" : "none"
                                      }}
                                    >
                                      #{item.node.clik.name}
                                    </Text>
                                  </View>
                                </TouchableOpacity>
                              )}
                            </Hoverable>

                            {this.getUserStar(item.node.notifier.username) ==
                              -1 && (
                                <Button
                                  title="Follow User"
                                  titleStyle={[ButtonStyle.wtitleStyle, { fontFamily: ConstantFontFamily.HeaderBoldFont }]}
                                  buttonStyle={[ButtonStyle.gbackgroundStyle, styles.notificationButtonStyle, { borderWidth: 0 }]}
                                  containerStyle={[ButtonStyle.containerStyle, { marginBottom: 0, marginLeft: 0, }]}
                                  onPress={() =>
                                    this.followUser(
                                      item.node.notifier.id,
                                      item.node.id
                                    )
                                  }
                                />
                              )}
                          </View>
                        </View>
                      </TouchableOpacity>
                    </View>
                  );
                }

                else if (
                  item.node.__typename == "ClikApplicationNotification"
                ) {
                  return (
                    <View
                      style={[
                        ButtonStyle.normalFeedStyleForDashboard, styles.boxWidth,

                      ]}
                    >
                      <TouchableOpacity
                        style={{ flexDirection: "row" }}
                      >
                        <View
                          style={{
                            width: "10%",
                            justifyContent: "center"
                          }}
                        >
                          <View style={{ alignSelf: 'center', }}>
                            <Image
                              source={require("../assets/image/logolastOne.png")}
                              style={{
                                width: 30,
                                height: 30,
                                borderRadius: 8
                              }}
                            />
                          </View>
                          <Text
                            style={{
                              marginTop: 10,
                              textAlign: "center",
                              color: "#000",
                              fontSize: 12,
                              fontWeight: "bold",
                              fontFamily: ConstantFontFamily.defaultFont
                            }}
                          >
                            {moment
                              .utc(item.node.created)
                              .local()
                              .fromNow(true)}
                          </Text>
                        </View>

                        <View
                          style={{
                            width: "85%"
                          }}
                        >
                          <View
                            style={{
                              flexDirection: "column",
                              alignItems: "center",
                              justifyContent: 'center',
                              padding: 5
                            }}
                          >
                            <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                              <Hoverable>
                                {isHovered => (
                                  <TouchableOpacity
                                    style={{
                                      flexDirection: 'row',
                                      alignItems: 'center'
                                    }}
                                    onPress={() => this.goToUserProfile(item.node.notifier.username)}

                                  >
                                    <Image
                                      source={{
                                        uri: item.node.notifier.profile_pic ? item.node.notifier.profile_pic :
                                          (item.node.notifier.profile_pic?.slice(-3) == "000" || item.node.notifier.profile_pic?.slice(-2) == "00") ?
                                            require("../assets/image/default-image.png")
                                            : require("../assets/image/default-image.png"),
                                      }}
                                      style={{
                                        width: 30,
                                        height: 30,
                                        borderRadius: 15,
                                      }}
                                    />
                                    <Text
                                      style={[ButtonStyle.profileTitleStyle, {
                                        color: "#000",
                                        textDecorationLine:
                                          isHovered == true ? "underline" : "none"
                                      }]}
                                    >
                                      @{item.node.notifier.username}
                                    </Text>
                                  </TouchableOpacity>
                                )}
                              </Hoverable>
                              <Text
                                style={{
                                  color: "#000",
                                  fontSize: 13,
                                  fontWeight: "bold",
                                  fontFamily: ConstantFontFamily.defaultFont
                                }}
                              >
                                wants to join
                              </Text>
                            </View>

                            <Hoverable>
                              {isHovered => (
                                <TouchableOpacity
                                  style={{
                                    justifyContent: "center",
                                    marginTop: 20,
                                    flexDirection: 'row',
                                    alignItems: 'center'
                                  }}
                                  onPress={() =>
                                    this.goToClikProfile(
                                      item.node.clik_application.clik.name
                                    )
                                  }
                                >
                                  <Image
                                    source={{
                                      uri: item.node.clik_application.clik.profile_pic ? item.node.clik_application.clik.profile_pic : "data:image/png;base64,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",
                                    }}
                                    style={{
                                      width: 30,
                                      height: 30,
                                      borderRadius: 5,
                                    }}
                                  />

                                  <View style={{
                                    backgroundColor: "#E8F5FA",
                                    padding: 5,
                                    borderRadius: 6,
                                    marginLeft: 10
                                  }}>
                                    <Text
                                      style={[ButtonStyle.profileTitleStyle, {
                                        width: "100%",
                                        color: "#4169e1",
                                        textDecorationLine:
                                          isHovered == true ? "underline" : "none"
                                      }]}
                                    >

                                      #{item.node.clik_application.clik.name}
                                    </Text>
                                  </View>
                                </TouchableOpacity>
                              )}
                            </Hoverable>


                            {item.node.clik_application.clik && item.node.clik_application.clik.qualifications && item.node.clik_application.clik.qualifications.length > 0 ?
                              <View style={{ justifyContent: 'center', flexDirection: 'row', alignItems: 'center', marginVertical: 10 }}>
                                <Text
                                  style={{
                                    fontFamily: ConstantFontFamily.defaultFont,
                                    color: "#000",
                                    fontWeight: "bold"
                                  }}
                                >
                                  {item.node.clik_application.clik && item.node.clik_application.clik.qualifications && item.node.clik_application.clik.qualifications.length > 0
                                    ? "Qualification" : " "}

                                </Text>
                                <Text style={{ fontFamily: ConstantFontFamily.defaultFont, }}>
                                  {item.node.clik_application.clik && item.node.clik_application.clik.qualifications && item.node.clik_application.clik.qualifications.length > 0
                                    ? item.node.clik_application.clik.qualifications[0]
                                    : ""}
                                </Text>
                              </View>
                              : null}

                            <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'center', marginTop: 14 }}>
                              <Button
                                title={"Accept"}
                                titleStyle={[ButtonStyle.wtitleStyle, { fontFamily: ConstantFontFamily.HeaderBoldFont }]}
                                buttonStyle={[ButtonStyle.gbackgroundStyle, styles.notificationButtonStyle, { marginHorizontal: 10, borderWidth: 0 }]}
                                containerStyle={[ButtonStyle.containerStyle, { marginVertical: 0 }]}
                                onPress={() =>
                                  this.acceptClik(item.node.clik_application.id)
                                }
                              />

                              <Button
                                title={"Reject"}
                                titleStyle={[ButtonStyle.wtitleStyle, { fontFamily: ConstantFontFamily.HeaderBoldFont }]}
                                buttonStyle={[ButtonStyle.rbackgroundStyle, styles.notificationButtonStyle, { marginHorizontal: 10, borderWidth: 0 }]}
                                containerStyle={[ButtonStyle.containerStyle, { marginVertical: 0 }]}
                                onPress={() =>
                                  this.rejectClik(
                                    item.node.clik_application.clik.id,
                                    item.node.notifier.id,
                                    item.node.id
                                  )
                                }
                              />
                            </View>
                          </View>
                        </View>
                      </TouchableOpacity>
                    </View>

                  );
                }

                else if (
                  item.node.__typename ==
                  "ClikApplicationAcceptedNotification"
                ) {
                  return (
                    <View
                      style={[
                        ButtonStyle.normalFeedStyleForDashboard, styles.boxWidth,
                      ]}
                    >
                      <View
                        style={{ flexDirection: "row" }}
                      >
                        <View
                          style={{
                            width: "10%",
                            justifyContent: "center"
                          }}
                        >
                          <View style={{ alignSelf: 'center' }}>
                            <Image
                              source={require("../assets/image/logolastOne.png")}
                              style={{
                                width: 30,
                                height: 30,
                                borderRadius: 8
                              }}
                            />
                          </View>
                          <Text
                            style={{
                              marginTop: 10,
                              textAlign: "center",
                              color: "#000",
                              fontSize: 12,
                              fontWeight: "bold",
                              fontFamily: ConstantFontFamily.defaultFont
                            }}
                          >
                            {moment
                              .utc(item.node.created)
                              .local()
                              .fromNow(true)}
                          </Text>
                        </View>
                        <View
                          style={{
                            width: "85%"
                          }}
                        >
                          <View
                            style={{
                              flexDirection: "column",
                              alignItems: "center",
                              justifyContent: 'center'
                            }}
                          >
                            <View style={{ flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                              <Hoverable>
                                {isHovered => (

                                  <TouchableOpacity
                                    style={{
                                      alignItems: 'center',
                                      flexDirection: 'row'
                                    }}
                                    onPress={() => this.goToUserProfile(item.node.notifier ? item.node.notifier.username : item.node.notifier.username)}
                                  >

                                    <Image
                                      source={{
                                        uri: item.node.notifier?.profile_pic ? item.node.notifier.profile_pic :
                                          (item.node.notifier?.profile_pic?.slice(-3) == "000" || item.node.notifier?.profile_pic?.slice(-2) == "00") ?
                                            require("../assets/image/default-image.png")
                                            :
                                            require("../assets/image/default-image.png"),
                                      }}
                                      style={{
                                        width: 30,
                                        height: 30,
                                        borderRadius: 15,
                                      }}
                                    />
                                    <Text
                                      style={{
                                        marginLeft: 5,
                                        color: "#000",
                                        fontSize: 16,
                                        fontFamily:
                                          ConstantFontFamily.defaultFont,
                                        textDecorationLine:
                                          isHovered == true ? "underline" : "none"
                                      }}
                                    >
                                      @{item.node.notifier ? item.node.notifier.username : item.node.notifier.username}
                                    </Text>

                                  </TouchableOpacity>
                                )}
                              </Hoverable>
                              <Text
                                style={{
                                  fontFamily: ConstantFontFamily.defaultFont,
                                  color: "#000",
                                  fontWeight: "bold"
                                }}
                              >
                                accepted your request to join
                              </Text>
                            </View>
                            <Hoverable>
                              {isHovered => (
                                <TouchableOpacity
                                  style={{
                                    justifyContent: "center",
                                    marginTop: 20,
                                    flexDirection: 'row',
                                    alignItems: 'center'
                                  }}
                                  onPress={() =>
                                    this.goToClikProfile(
                                      item.node.clik_application.clik.name
                                    )
                                  }
                                >
                                  <Image
                                    source={{
                                      uri: item.node.clik_application.clik.profile_pic ? item.node.clik_application.clik.profile_pic : "data:image/png;base64,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",
                                    }}
                                    style={{
                                      width: 30,
                                      height: 30,
                                      borderRadius: 5,
                                    }}
                                  />

                                  <View style={{
                                    backgroundColor: "#E8F5FA",
                                    padding: 5,
                                    borderRadius: 6,
                                    marginLeft: 10
                                  }}>
                                    <Text
                                      style={{
                                        width: "100%",
                                        color: "#4169e1",
                                        fontSize: 15,
                                        fontFamily:
                                          ConstantFontFamily.defaultFont,
                                        textDecorationLine:
                                          isHovered == true ? "underline" : "none"
                                      }}
                                    >
                                      {" "}
                                      #{item.node.clik_application.clik.name}{" "}
                                    </Text>
                                  </View>

                                </TouchableOpacity>
                              )}
                            </Hoverable>
                          </View>
                        </View>
                      </View>
                    </View>
                  );
                }

                else if (
                  item.node.__typename ==
                  "UserInviteAcceptedNotification"
                ) {
                  return (
                    <View
                      style={[
                        ButtonStyle.normalFeedStyleForDashboard, styles.boxWidth,
                      ]}
                    >
                      <View
                        style={{ flexDirection: "row" }}
                      >
                        <View
                          style={{
                            width: "10%",
                            justifyContent: "center"
                          }}
                        >
                          <Image
                            source={require("../assets/image/default-image.png")}
                            style={{
                              width: 40,
                              height: 40,
                              borderRadius: 30,
                              borderWidth: 1,
                              borderColor: "#e1e1e1",
                              alignSelf: "center",
                              marginBottom: 10
                            }}
                          />
                          <Text
                            style={{
                              marginTop: 10,
                              textAlign: "center",
                              color: "#000",
                              fontSize: 12,
                              fontWeight: "bold",
                              fontFamily: ConstantFontFamily.defaultFont
                            }}
                          >
                            {moment
                              .utc(item.node.created)
                              .local()
                              .fromNow(true)}{" "}
                          </Text>
                        </View>

                        <View
                          style={{
                            width: "85%"
                          }}
                        >
                          <View
                            style={{
                              width: "100%",
                              padding: 10,
                              alignItems: "center"
                            }}
                          >
                            <Hoverable>
                              {isHovered => (
                                <TouchableOpacity
                                  style={{ flexDirection: 'row', alignItems: 'center' }}
                                  onPress={() => this.goToUserProfile(item.node.contents.invitee.username)}
                                >

                                  <Image
                                    source={{
                                      uri: item.node.contents.invitee.profile_pic ?
                                        item.node.contents.invitee.profile_pic :
                                        (item.node.contents.invitee.profile_pic?.slice(-3) == "000" || item.node.contents.invitee.profile_pic?.slice(-2) == "00") ?
                                          require("../assets/image/default-image.png")
                                          :
                                          require("../assets/image/default-image.png"),
                                    }}
                                    style={{
                                      width: 30,
                                      height: 30,
                                      borderRadius: 15,
                                    }}
                                  />
                                  <Text
                                    style={[styles.usernameText, {
                                      textDecorationLine:
                                        isHovered == true ? "underline" : "none"
                                    }]}
                                  >
                                    @{item.node.contents.invitee.username}
                                  </Text>

                                </TouchableOpacity>
                              )}
                            </Hoverable>
                            <Text
                              style={{
                                color: "#000",
                                fontSize: 13,
                                fontWeight: "bold",
                                fontFamily: ConstantFontFamily.defaultFont
                              }}
                            >
                              {" "}
                              accepted your invitation to weclikd!
                            </Text>
                          </View>

                          {this.getUserStar(
                            item.node.contents.invitee.username
                          ) == -1 && (
                              <View
                                style={{ alignSelf: "center", marginBottom: 10 }}
                              >
                                <Button
                                  title="Follow User"
                                  titleStyle={[ButtonStyle.wtitleStyle, { fontFamily: ConstantFontFamily.HeaderBoldFont }]}
                                  buttonStyle={[ButtonStyle.gbackgroundStyle, styles.notificationButtonStyle, { borderWidth: 0 }]}
                                  containerStyle={[ButtonStyle.containerStyle, { marginVertical: 0 }]}
                                  onPress={() =>
                                    this.followUser(
                                      item.node.contents.invitee.id,
                                      item.node.id
                                    )
                                  }
                                />
                              </View>
                            )}
                        </View>
                        <View
                          style={{ height: 2, backgroundColor: "#e1e1e1" }}
                        ></View>
                      </View>
                    </View>
                  );
                }
                else if (item.node.__typename == "ContentSharedNotification" && item.node.content != null) {

                  return (

                    <View
                      style={[
                        ButtonStyle.normalFeedStyleForDashboard, styles.boxWidth,

                      ]}
                    >

                      <View

                        style={{
                          flexDirection: "row",
                          width: "100%"
                        }}
                      >
                        <View
                          style={{
                            width: "10%",
                            justifyContent: "center"
                          }}
                        >
                          <Icon
                            color={Colors.blueColor}
                            name={"comment"}
                            type="font-awesome"
                            size={30}
                            iconStyle={{ alignSelf: "center" }}
                            containerStyle={{ alignSelf: "center" }}
                          />
                          <Text
                            style={{
                              marginTop: 10,
                              textAlign: "center",
                              color: "#000",
                              fontSize: 12,
                              fontWeight: "bold",
                              fontFamily: ConstantFontFamily.defaultFont
                            }}
                          >
                            {" "}
                            {moment
                              .utc(item.node.created)
                              .local()
                              .fromNow(true)}{" "}
                          </Text>
                        </View>

                        <View
                          style={{
                            width: "90%"
                          }}
                        >
                          <View
                            style={{
                              width: "100%",
                              padding: 20,
                            }}
                          >
                            <Text
                              style={{
                                color: "#000",
                                fontFamily: ConstantFontFamily.defaultFont,
                                fontSize: 13,
                                fontWeight: 'bold',
                              }}

                            >


                              {

                                item?.node?.content?.text ?
                                  item?.node?.content.text?.replace(regex, '') : item?.node?.content?.title
                              }


                            </Text>
                            <Hoverable>
                              {isHovered => (
                                <TouchableOpacity
                                  style={{ flexDirection: 'row', alignItems: 'center' }}
                                  onPress={() => this.goToUserProfile(item.node.notifier.username)}
                                >
                                  <Image
                                    source={{
                                      uri: item.node.notifier.profile_pic ?
                                        item.node.notifier.profile_pic :
                                        (item.node.notifier.profile_pic?.slice(-3) == "000" || item.node.notifier.profile_pic?.slice(-2) == "00") ?
                                          require("../assets/image/default-image.png")
                                          :
                                          require("../assets/image/default-image.png"),
                                    }}
                                    style={{
                                      width: 30,
                                      height: 30,
                                      borderRadius: 15,
                                    }}
                                  />
                                  <Text style={[styles.usernameText, {
                                    textDecorationLine:
                                      isHovered == true ? "underline" : "none"
                                  }]}
                                  >
                                    {"@" + item.node.notifier.username}
                                    {" "} </Text>
                                </TouchableOpacity>
                              )}
                            </Hoverable>
                          </View>

                          <View
                            style={{
                              marginBottom: 10,
                              padding: 20
                            }}
                          >

                            <Text
                              style={{
                                color: "#000",
                                fontFamily: ConstantFontFamily.defaultFont,
                                fontSize: 13,
                                fontWeight: 'bold',
                              }}
                            >
                              {

                                item?.node?.content?.text ?
                                  item?.node?.content.text?.replace(regex, '') : item?.node?.content?.title
                              }
                            </Text>
                            <Hoverable>
                              {isHovered => (
                                <TouchableOpacity
                                  style={{ flexDirection: 'row', alignItems: 'center' }}
                                  onPress={() => this.goToUserProfile(
                                    item.node.notifier
                                      .username)}
                                >
                                  <Image
                                    source={{
                                      uri: item.node.notifier.profile_pic ?
                                        item.node.notifier.profile_pic :
                                        (item.node.notifier.profile_pic?.slice(-3) == "000" || item.node.notifier.profile_pic?.slice(-2) == "00") ?
                                          require("../assets/image/default-image.png")
                                          :
                                          require("../assets/image/default-image.png"),
                                    }}
                                    style={{
                                      width: 30,
                                      height: 30,
                                      borderRadius: 15,
                                    }}
                                  />
                                  <Text style={[styles.usernameText, {
                                    textDecorationLine:
                                      isHovered == true ? "underline" : "none"
                                  }]}
                                  >
                                    {"@" + item.node.notifier
                                      .username}
                                    {" "} </Text>
                                </TouchableOpacity>
                              )}
                            </Hoverable>
                          </View>
                        </View>

                        <View
                          style={{ height: 2, backgroundColor: "#e1e1e1" }}
                        ></View>
                      </View>
                    </View>
                  );
                }
              })}
            </View>
          )}
        </ScrollView>
      </View>
    );
  }
}

const mapStateToProps = state => ({
  profileData: state.LoginUserDetailsReducer.userLoginDetails,
  getUserFollowFeedList: state.LoginUserDetailsReducer.userFollowFeedList
    ? state.LoginUserDetailsReducer.userFollowFeedList
    : [],
  getUserFollowTopicList: state.LoginUserDetailsReducer.userFollowTopicsList
    ? state.LoginUserDetailsReducer.userFollowTopicsList
    : [],
  getUserFollowUserList: state.LoginUserDetailsReducer.userFollowUserList
    ? state.LoginUserDetailsReducer.userFollowUserList
    : [],
  getUserFollowCliksList: state.LoginUserDetailsReducer.userFollowCliksList
    ? state.LoginUserDetailsReducer.userFollowCliksList
    : [],
  getsearchBarStatus: state.AdminReducer.get("searchBarOpenStatus"),

});

const mapDispatchToProps = dispatch => ({
  setPostDetails: payload => dispatch(setPostDetails(payload)),
  setPostCommentDetails: payload => dispatch(setPostCommentDetails(payload)),
  setComment: payload => dispatch({ type: "SET_COMMENT", payload }),
  setNotificationId: payload => dispatch({ type: "GET_NOTIFICATION_ID", payload }),
  saveLoginUser: payload => dispatch(saveUserLoginDaitails(payload)),
  ClikId: payload => dispatch(getTrendingCliksProfileDetails(payload)),
  userId: (payload) => dispatch(getCurrentUserProfileDetails(payload)),
  searchOpenBarStatus: (payload) =>
    dispatch({ type: "SEARCHBAR_STATUS", payload }),
  feedFluctuation: (payload) => dispatch(feedFluctuation(payload)),
  screen: (payload) => dispatch(screen(payload))

});


export default compose(connect(mapStateToProps, mapDispatchToProps))(
  NotificationScreen
);

const styles = StyleSheet.create({
  notificationButtonStyle: {
    borderRadius: 20,
    paddingVertical: 7,
    paddingHorizontal: 25
  },
  boxWidth: {
    width: '96%',
    marginLeft: Dimensions.get("window").width <= 1200 ? 8 : 15,
    backgroundColor: "#fff",
    paddingHorizontal: 5,
    paddingVertical: 20
  },
  usernameText: {
    color: "#000",
    fontSize: 15,
    fontFamily:
      ConstantFontFamily.defaultFont,

    marginLeft: 10
  }
})